<template>
  <div class="modal-mask u-box-shadow" v-if="show">
    <div class="modal-wrapper" @click="$emit('close')">
      <div class="modal-container">
        <div class="modal-header">
          <slot name="header" v-html="modalContent"></slot>
        </div>

        <div class="modal-body">
          <slot name="body">
            <div class="u-text-align--right">
              <h5>Downloads</h5>
              <div v-for="key in modalContent.UrlTermsAndConditions" :key="key">
                <a :href="key.Url">{{key.Title}}</a>
              </div>
            </div>
            <div>
              <b>Aanmelding houdt in dat u uitdrukkelijk akkoord bent met</b>
              <br>
              <ul>
                <li v-for="item in modalContent.ConditionsList" :key="item">{{item}}</li>
              </ul>
            </div>
            <div>
              <b>Samenvatting voorwaarden:</b>
              <br>
              <div class="layout" style="max-width: 700px; ">
                <div class="layout__item u-1/3-default u-font-weight--bold">Productgegevens</div>
                <div
                  class="layout__item u-2/3-default"
                >{{modalContent.DiscountCondition["Productgegevens"]}}</div>

                <div class="layout__item u-1/3-default u-font-weight--bold">Leverancier</div>
                <div
                  class="layout__item u-2/3-default"
                >{{modalContent.DiscountCondition["Leverancier"]}}</div>

                <div class="layout__item u-1/3-default u-font-weight--bold">Tariefsoort</div>
                <div
                  class="layout__item u-2/3-default"
                >{{modalContent.DiscountCondition["Tariefsoort"]}}</div>

                <div class="layout__item u-1/3-default u-font-weight--bold">Duur levering</div>
                <div
                  class="layout__item u-2/3-default"
                >{{modalContent.DiscountCondition["Duur levering"]}}</div>

                <div class="layout__item u-1/3-default u-font-weight--bold">Welkomstpremie</div>
                <div
                  class="layout__item u-2/3-default"
                >{{modalContent.DiscountCondition["Welkomstpremie"]}}</div>

                <div
                  class="layout__item u-1/3-default u-font-weight--bold"
                  v-if="modalContent.DiscountCondition['Begrenzing stroom'] || modalContent.DiscountCondition['Begrenzing gas']"
                >Begrenzing</div>
                <div
                  class="layout__item u-2/3-default"
                  v-if="modalContent.DiscountCondition['Begrenzing stroom'] || modalContent.DiscountCondition['Begrenzing gas']"
                >
                  {{modalContent.DiscountCondition["Begrenzing stroom"]}}
                  {{modalContent.DiscountCondition["Begrenzing gas"]}}
                </div>

                <div
                  v-if="modalContent.DiscountCondition['Bijzonderheden']"
                  class="layout__item u-1/3-default u-font-weight--bold"
                >Bijzonderheden</div>
                <div
                  v-if="modalContent.DiscountCondition['Bijzonderheden']"
                  class="layout__item u-2/3-default"
                >{{modalContent.DiscountCondition["Bijzonderheden"]}}</div>
              </div>
            </div>
          </slot>
        </div>

        <div class="modal-footer">
          <slot name="footer">
            <p v-html="modalContent.footer"></p>
          </slot>
          <button class="c-button u-float--right" @click="close()">Sluiten</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
	props: ['modalContent', 'show'],
	methods: {
		close() {
			this.$emit('close');
		}
	}
};
</script>

<style>
.modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: table;
    transition: opacity 0.3s ease;
}

.modal-wrapper {
    display: table-cell;
    vertical-align: middle;
}

.modal-container {
    min-width: 80vw;
    max-width: 100vw;
    max-width: 1000px;
    margin: 0 auto;
    padding: 20px 30px;
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    transition: all 0.3s ease;
    font-family: Helvetica, Arial, sans-serif;
    height: 80vh;
    overflow-y: scroll;
}

.modal-header h3 {
    margin-top: 0;
    color: #42b983;
}

.modal-body {
    margin: 20px 0;
}

.modal-default-button {
    float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
    opacity: 0;
}

.modal-leave-active {
    opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
}
</style>
